const Auxiliar = (props) => props.children;

export default Auxiliar;


// WEBPACK FOOTER //
// ./src/hoc/Auxiliar/Auxiliar.js